import { PlatformModule } from '@angular/cdk/platform';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BixiTableModule } from '@bixi/core/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { MUploadFileListComponent } from './upload-file-list.component';

@NgModule({
  declarations: [MUploadFileListComponent],
  exports: [MUploadFileListComponent],
  imports: [CommonModule, PlatformModule, NzIconModule, NzUploadModule, BixiTableModule, NzButtonModule]
})
export class MUploadFileListModule {}
